import { render, staticRenderFns } from "./input-question.vue?vue&type=template&id=0aa8f47e"
import script from "./input-question.vue?vue&type=script&lang=js"
export * from "./input-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports